import { ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { Http } from '@angular/http';
import { MatChipInputEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from '../../core/backend.service';
import { HistoryProvider } from '../../core/browser-providers';
import { CodigoPromocionAdd } from '../../pedido/codigos-promocion/codigo-descuento-add.model';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { MediaService } from '../../shared-services/media.service';
import { NavigationService } from '../../shared-services/navigation.service';
import { SnackService } from '../../shared-services/snack.service';

@Component({
  selector: 'app-producto-codigo-descuento',
  templateUrl: './producto-codigo-descuento.component.html',
  styleUrls: ['./producto-codigo-descuento.component.scss']
})
export class ProductoCodigoDescuentoComponent implements OnInit {

  separatorKeysCodes: number[] = [ENTER];
  
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  @ViewChild('form') public roleForm: NgForm;
  toppings = new FormControl();
  @ViewChild('fruitInput') fruitInput: ElementRef;

  validationFail = false;

  messageTitle: string;
  price: number = 0;
  validDates = [];
  maximoHasta: string;

  updateCodigo: CodigoPromocionAdd = new CodigoPromocionAdd();


  myFilter = (d: Date): boolean => {
    return !this.validDates[d.toISOString()];
  }

  isHD = false;

  sinLimiteTiempo: Boolean = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    private renderer: Renderer2,
    @Inject(HistoryProvider) private history: History,
    private http: Http,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
    private activatedRoute: ActivatedRoute,
  ) { }

  async ngOnInit() {

    this.snackService.spinner(true);

    this.messageTitle = "Creacion de Código de Promoción"
    
    this.updateCodigo.porcentajeDescuento = 0;
    this.updateCodigo.etiquetaModificacionPrecio = "";
    this.updateCodigo.productoId=this.activatedRoute.snapshot.params.id;

    this.snackService.spinner(false);

    console.log(this.updateCodigo);


  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }
  
  back() {
    this.navigationService.back();
  }


  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
  }

  async save() {
    if (this.validateForm()) {
      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }

    return;
  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea modificar los precios'/* + this.banner.description*/ +'?')
    .then( res => {
      if (res) {
       this.saveItem(res);
      }
    });
  }
  
  async saveItem(res) {
    if (res) {

      this.snackService.spinner(true);
       // Update       
        try {
          
           await this.backendService.create("/new-productos/add-codigo-descuento", this.updateCodigo);
          this.snackService.success('Código Agregado');
          this.router.navigate(['/codigos-promocion']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
        
      }
    }
    
    async getRango() {
      let i = 0 ;
      while ( i < 90) {
        this.maximoHasta = '';
        const fechaSiguiente = new Date(this.updateCodigo.fechaDesde);
        fechaSiguiente.setDate(fechaSiguiente.getDate() + i);
        if (this.validDates[fechaSiguiente.toISOString()]) {
          this.maximoHasta = fechaSiguiente.toISOString();
          return;
        } else {
          i++;
        }
      }
    }

    sinLimiteFecha(){
      
      if(this.sinLimiteTiempo){
        this.updateCodigo.fechaHasta = "3000-06-09T03:00:00.000Z";
        this.sinLimiteTiempo = false;
      }else{
        this.updateCodigo.fechaHasta=null;
        this.sinLimiteTiempo = true;
      }
      
    }


}



// WEBPACK FOOTER //
// ./src/app/productos/producto-codigo-descuento/producto-codigo-descuento.component.ts